export default function Marquee({ items }) {
  const Row = ({ hidden }) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 text-[11px] font-semibold uppercase tracking-[0.25em] text-navy-soft">
            {item}
          </span>
          <span className="h-1 w-1 bg-blue" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee overflow-hidden border-y border-line bg-paper-band py-4">
      <div className="marquee-track flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}